<template>
    <div :id="page_slug">
        <div class="crumbs-bar">
            <el-row>
                <el-col :span="12">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ name: 'ProductCategoryList' }">Product Categories</el-breadcrumb-item>
                    <el-breadcrumb-item>Edit</el-breadcrumb-item>
                </el-breadcrumb>        
                </el-col>      
            </el-row>
            </div>

        <el-form 
            ref="category" 
            :rules="rules.category"
            :model="category"
            :label-position="label_position">

            <el-form-item label="Name" prop="name">
                <el-input v-model="category.name"></el-input>
            </el-form-item>

            <el-form-item label="Sort Order" prop="sort_order">
                <el-input-number controls-position="right" :min="0" v-model="category.sort_order"></el-input-number>
            </el-form-item>

            <el-form-item label="Is Hidden">
                <el-switch
                    :inactive-value="0"
                    :active-value="1"
                    v-model="category.is_hidden">
                </el-switch>
            </el-form-item>

        <el-form-item>
            <el-button type="primary" @click="updateCategory('category')">Update</el-button>
            </el-form-item>
        </el-form>

        <pre>{{$data}}</pre>
    </div>
</template>

<script>
    import Config from '@/store/Config.js';
    import Utils from '@/components/utils/Utils.js';
    import Auth from '@/components/auth/AuthCheck.js';

    export default {
        data: function() {
            return {
                config: Config.config,
                page_alias: 'Edit Category',
                page_slug: 'edit-category',
                label_position: 'top',
                rules: {
                    category: {
                        name: [
                            {required: true, message: 'Please Enter Name', trigger: 'blur'}
                        ],
                        sort_order: [
                            {required: true, message: 'Please Enter Sort Order', trigger: 'blur' },
                            {type: 'integer', message: 'Please Enter Number', trigger: 'blur'}
                        ],
                    }
                },  
                category: {
                    name: '',
                    url_name: '',
                    sort_order: '',
                    is_hidden: '',
                    updated_user_id: ''
                }
            };
        },

        mounted: function() {
            const me = this;
            me.getCategory();
        },

        methods: {
            getCategory: function() {
                console.log('get category function');
                const me = this;
                me.$http.get(me.config.api + 'productCategory/{id}', {params: {backend_call: 1, id : me.$route.params.id}}).then(
                response => {
                    console.log('Success Getting Data')  
                    console.log(response.status);
                    console.log(response.statusText);
                    me.category = response.body.data;
                }, response => {
                    console.log('Error Getting Data');
                    console.log(response.status);
                    console.log(response.statusText);
                });
            },

            updateCategory: function(formName) {
                console.log('update category function');
                const me = this;
                me.$refs[formName].validate((valid) => {
                    if (valid) {
                        var jwt = Utils.decodejwt();
                        me.category.updated_user_id = jwt.sub;
                        me.$http.put(me.config.api + 'productCategory/{id}', me.category, {params: {id : me.$route.params.id}}).then(
                        response => {
                            console.log('success putting data')  
                            console.log(response.status);
                            console.log(response.statusText);
                            me.getCategory();
                            me.$notify({
                                title: 'Success',
                                message: 'The Category Was Updated',
                                type: 'success'
                            });
                        }, response => {
                            console.log('Error Getting Data');
                            console.log(response.status);
                            console.log(response.statusText);
                        });
                    } else {
                        console.log('Fields Not Valid');
                        return false;
                    }
                });   
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/pages/product-categories/ProductCategoryEdit.vue